import AdsError from './AdsError.js'

export default class InvalidRequestError extends AdsError {}
